import { TranslationSourceWithContextItem } from '@bolteu/translations-service';
import { TranslationFile } from '@bolteu/translations-service/src/types';

type DeepReadonly<T> = T extends object ? { readonly [K in keyof T]: DeepReadonly<T[K]> } : T;

const hasContext = (value: unknown): value is TranslationSourceWithContextItem => {
  return typeof value === 'object' && value !== null && 'text' in value && 'context' in value;
};

export function transform<T>(
  obj: Record<string, string | TranslationSourceWithContextItem | TranslationFile>,
  prependingPath = '',
): DeepReadonly<T> {
  const newObj = {} as Record<string, string>;
  Object.entries(obj).forEach(([key, value]) => {
    const path = `${prependingPath}${key}`;
    if (typeof value === 'string' || hasContext(value)) {
      newObj[key] = path;
    } else {
      newObj[key] = transform(value, `${path}.`);
    }
  });
  return newObj as DeepReadonly<T>;
}
